import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DateTimeService {
  public returnTime() {
    const today = new Date();
    const dateTime: string[] = [];
    const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    dateTime.push(date);
    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    dateTime.push(time);

    console.table([
      [ 'Date', date ],
      [ 'Date type', typeof date ],
      [ 'Time', time ],
      [ 'Time type', typeof time ],
      [ 'Final', dateTime ]
    ]);

    return dateTime;
  }  
}
